import { Input } from "../../../common/components/Input";
import { Button } from "../../../common/components/Button";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { setPersonInfo } from "../../../app/rootReducer";
import { Link, useNavigate } from "react-router-dom";
import { ChangeEvent, FormEvent, JSX, useCallback } from "react";
import { handleSubmit } from "../utils/handleSubmit";
import { handleSkipAndExit } from "../utils/handleSkipAndExit";
import { RouteEnum } from "../../../common/enums/RouteEnum";

export const LeaveInformationContentForm = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const { personInfo } = useAppSelector((state) => state.root);
    const navigate = useNavigate();

    const handleFieldChange = useCallback(
        (field: keyof typeof personInfo) =>
            (e: ChangeEvent<HTMLInputElement>) => {
                dispatch(
                    setPersonInfo({
                        ...personInfo,
                        [field]: e.target.value,
                    }),
                );
            },
        [dispatch, personInfo],
    );

    const onSubmit = useCallback(
        (e: FormEvent) => {
            e.preventDefault();

            // Validate that terms are accepted
            if (!personInfo?.agreeOnTerms) {
                alert(
                    "You must agree to the terms and conditions to continue.",
                );
                return;
            }

            handleSubmit({
                personInfo,
                navigate,
            }).catch(console.error);
        },
        [personInfo, navigate],
    );

    const onSkipAndExit = useCallback(() => {
        handleSkipAndExit({
            personInfo,
            navigate,
        }).catch(console.error);
    }, [personInfo, navigate]);

    return (
        <form
            className="p-leave-information__content__form"
            onSubmit={onSubmit}
        >
            <div className="p-leave-information__content__form__form-group">
                <label htmlFor="name">Name</label>
                <Input
                    id="name"
                    placeholder="Fill in your name"
                    type="text"
                    value={personInfo?.name ?? ""}
                    required
                    onChange={handleFieldChange("name")}
                />
            </div>

            <div className="p-leave-information__content__form__form-group">
                <label htmlFor="email">Email address</label>
                <Input
                    id="email"
                    type="email"
                    placeholder="Fill in your email address"
                    value={personInfo?.email ?? ""}
                    required
                    onChange={handleFieldChange("email")}
                />
            </div>

            <div className="p-leave-information__content__form__form-group">
                <label htmlFor="company">Company name (optional)</label>
                <Input
                    id="company"
                    type="text"
                    placeholder="Fill in your company name"
                    value={personInfo?.company ?? ""}
                    onChange={handleFieldChange("company")}
                />
            </div>

            <div className="p-leave-information__content__form__form-group">
                <label className="p-leave-information__content__form__checkbox-label">
                    <input
                        type="checkbox"
                        id="agreeOnTerms"
                        checked={personInfo?.agreeOnTerms ?? false}
                        onChange={(e) => {
                            dispatch(
                                setPersonInfo({
                                    ...personInfo,
                                    agreeOnTerms: e.target.checked,
                                }),
                            );
                        }}
                        required
                    />
                    I agree to the&nbsp;
                    <Link to={RouteEnum.TERMS_AND_CONDITIONS}>
                        Terms & Conditions
                    </Link>
                    &nbsp;of this raffle
                </label>
            </div>

            <div className="p-leave-information__content__form__form-group p-leave-information__content__form__form-group--buttons">
                <Button type="submit" variant="secondary">
                    Enter to win
                </Button>
                <p onClick={onSkipAndExit}>Vote and exit</p>
            </div>
        </form>
    );
};
